export const DecorationType = Object.freeze({
  full: 'full',
  head: 'head',
  body: 'body',
  tail: 'tail',
});
